/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AddUserToGroupQueryVariables = Types.Exact<{ [key: string]: never }>

export type AddUserToGroupQuery = {
  __typename?: 'Query'
  backofficeUsers: Array<
    | {
        __typename?: 'BackofficeUser'
        id: string
        username: string
        email: string
      }
    | { __typename?: 'BackofficeUserLimited' }
  > | null
}

export type BackofficeUserManagementAddUserToGroupMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementAddUserToGroupInput
  }>

export type BackofficeUserManagementAddUserToGroupMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementAddUserToGroup: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
    timedGroups: Array<{
      __typename?: 'BackofficeUserTimeGroup'
      groupName: string
      expires: string | null
    }>
  }
}

export const AddUserToGroupDocument = gql`
    query AddUserToGroup {
  backofficeUsers {
    ... on BackofficeUser {
      id
      username
      email
    }
  }
}
    `

/**
 * __useAddUserToGroupQuery__
 *
 * To run a query within a React component, call `useAddUserToGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddUserToGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddUserToGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AddUserToGroupQuery,
    AddUserToGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AddUserToGroupQuery, AddUserToGroupQueryVariables>(
    AddUserToGroupDocument,
    options,
  )
}
export function useAddUserToGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddUserToGroupQuery,
    AddUserToGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AddUserToGroupQuery, AddUserToGroupQueryVariables>(
    AddUserToGroupDocument,
    options,
  )
}
// @ts-ignore
export function useAddUserToGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AddUserToGroupQuery,
    AddUserToGroupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AddUserToGroupQuery,
  AddUserToGroupQueryVariables
>
export function useAddUserToGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AddUserToGroupQuery,
        AddUserToGroupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AddUserToGroupQuery | undefined,
  AddUserToGroupQueryVariables
>
export function useAddUserToGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AddUserToGroupQuery,
        AddUserToGroupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AddUserToGroupQuery,
    AddUserToGroupQueryVariables
  >(AddUserToGroupDocument, options)
}
export type AddUserToGroupQueryHookResult = ReturnType<
  typeof useAddUserToGroupQuery
>
export type AddUserToGroupLazyQueryHookResult = ReturnType<
  typeof useAddUserToGroupLazyQuery
>
export type AddUserToGroupSuspenseQueryHookResult = ReturnType<
  typeof useAddUserToGroupSuspenseQuery
>
export type AddUserToGroupQueryResult = Apollo.QueryResult<
  AddUserToGroupQuery,
  AddUserToGroupQueryVariables
>
export const BackofficeUserManagementAddUserToGroupDocument = gql`
    mutation backofficeUserManagementAddUserToGroup($input: BackofficeUserManagementAddUserToGroupInput!) {
  backofficeUserManagementAddUserToGroup(input: $input) {
    id
    username
    timedGroups {
      groupName
      expires
    }
  }
}
    `
export type BackofficeUserManagementAddUserToGroupMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementAddUserToGroupMutation,
    BackofficeUserManagementAddUserToGroupMutationVariables
  >

/**
 * __useBackofficeUserManagementAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementAddUserToGroupMutation, { data, loading, error }] = useBackofficeUserManagementAddUserToGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementAddUserToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementAddUserToGroupMutation,
    BackofficeUserManagementAddUserToGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementAddUserToGroupMutation,
    BackofficeUserManagementAddUserToGroupMutationVariables
  >(BackofficeUserManagementAddUserToGroupDocument, options)
}
export type BackofficeUserManagementAddUserToGroupMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementAddUserToGroupMutation>
export type BackofficeUserManagementAddUserToGroupMutationResult =
  Apollo.MutationResult<BackofficeUserManagementAddUserToGroupMutation>
export type BackofficeUserManagementAddUserToGroupMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementAddUserToGroupMutation,
    BackofficeUserManagementAddUserToGroupMutationVariables
  >
